module.exports = __webpack_public_path__ + "static/media/forget-password-background.22cf9f90.png";